import { cx } from '@linaria/core';
import { resets } from '@ui/css';
import { FloatingActionButton } from '@ui/kit';
import { CrossIcon } from '@ui/kit/icons';
import { axisContext } from './context.js';
import { list, wrapper, closeButton } from './menu.style.js';
import { jsx } from 'react/jsx-runtime';

function FloatingActionButtonsContextMenu(props) {
  return /*#__PURE__*/jsx(axisContext.Provider, {
    value: props.axis,
    children: /*#__PURE__*/jsx("div", {
      className: cx(resets.rootCls, wrapper, props.className, props.axis),
      children: /*#__PURE__*/jsx("ul", {
        className: list,
        children: props.children
      })
    })
  });
}
function FloatingCloseButton(props) {
  return /*#__PURE__*/jsx(FloatingActionButton, {
    ref: props.ref,
    tooltip: {
      ariaType: "label",
      body: props.tooltip,
      placement: "right"
    },
    className: closeButton,
    onClick: props.onClick,
    disabled: props.disabled,
    children: /*#__PURE__*/jsx(FloatingActionButton.Icon, {
      children: /*#__PURE__*/jsx(CrossIcon, {
        height: "24",
        strokeWidth: 0.5
      })
    })
  });
}

export { FloatingActionButtonsContextMenu, FloatingCloseButton };
//# sourceMappingURL=menu.js.map
